import React from "react";
import "../About/About.css";

const About = () => {
  return (
    <section className="about-section">
      <div className="about-left">
        <h2>About Us</h2>
        <p className="subtext">
          Leaders in sustainable and innovative plant services.
        </p>
        <p className="description">
          We specialize in creating thriving green environments through a
          commitment to quality and innovation. Our team delivers customized
          solutions for plant care and landscaping to ensure your spaces stay
          lush and vibrant.
        </p>
        <div className="progress-bars">
          <div className="progress-item">
            <span>Office Plants</span>
            <div className="progress">
              <div className="progress-fill" style={{ width: "80%" }}></div>
            </div>
            <span className="percentage">80%</span>
          </div>
          <div className="progress-item">
            <span>Field Management</span>
            <div className="progress">
              <div className="progress-fill" style={{ width: "70%" }}></div>
            </div>
            <span className="percentage">70%</span>
          </div>
          <div className="progress-item">
            <span>Landscape Design</span>
            <div className="progress">
              <div className="progress-fill" style={{ width: "85%" }}></div>
            </div>
            <span className="percentage">85%</span>
          </div>
          <div className="progress-item">
            <span>Garden Care</span>
            <div className="progress">
              <div className="progress-fill" style={{ width: "65%" }}></div>
            </div>
            <span className="percentage">65%</span>
          </div>
        </div>
      </div>
      <div className="about-right">
        <div className="card">
          <img src="a1.webp" alt="Quality Products" />
          <h4>Quality Products</h4>
          <p>Delivering premium-grade plants to meet your expectations.</p>
        </div>
        <div className="card">
          <img src="a2.webp" alt="Perfect Service" />
          <h4>Perfect Service</h4>
          <p>Professional solutions tailored to your plant care needs.</p>
        </div>
        <div className="card">
          <img src="a3.webp" alt="100% Natural" />
          <h4>100% Natural</h4>
          <p>Embracing nature with sustainable and eco-friendly practices.</p>
        </div>
        <div className="card">
          <img src="a4.webp" alt="Environmentally Friendly" />
          <h4>Environmentally Friendly</h4>
          <p>Innovative methods to maintain a greener planet.</p>
        </div>
      </div>
    </section>
  );
};

export default About;
